import axios from "axios";
import * as types from "./notificationsTypes";
import { NOTIFICATIONS } from "~/utils/urlApi";

export const getAllNotification = async ({ user_id, access_token, total }) => {
  const { data } = await axios.get(
    NOTIFICATIONS.GET_NOTIFICATION_URL +
      `?user_id=${user_id}&access_token=${access_token}&type=${types.TYPE}&limit=${total}&offset=0`
  );
  return data;
};

export const getNotification = async ({ user_id, access_token }) => {
  const { data } = await axios.get(
    NOTIFICATIONS.GET_NOTIFICATION_URL +
      `?user_id=${user_id}&access_token=${access_token}&type=${types.TYPE}&limit=${types.LIMIT}&offset=0`
  );
  return data;
};

export const getMoreNotification = async ({
  user_id,
  access_token,
  offset
}) => {
  const { data } = await axios.get(
    NOTIFICATIONS.GET_NOTIFICATION_URL +
      `?user_id=${user_id}&access_token=${access_token}&type=${types.TYPE}&limit=${types.LIMIT}&offset=${offset}`
  );
  return data;
};

export const getNotificationOnPage = async ({
  user_id,
  access_token,
  page,
  type
}) => {
  const { data } = await axios.get(
    NOTIFICATIONS.GET_NOTIFICATION_URL +
      `?user_id=${user_id}&access_token=${access_token}&type=${type}&limit=${
        types.NUMBER_ON_PAGE
      }&offset=${page * types.NUMBER_ON_PAGE}`
  );
  return data;
};

export const updateReadNotification = async ({
  noti_id,
  user_id,
  access_token
}) => {
  const { data } = await axios.post(
    NOTIFICATIONS.UPDATE_READ_NOTIFICATION_URL +
      `?noti_id=${noti_id}&user_id=${user_id}&access_token=${access_token}`
  );
  return data;
};

export const getNotiIdList = async ({ user_id, access_token, total }) => {
  const { data } = await getAllNotification({
    user_id,
    access_token,
    total
  });
  return data.map(noti => noti.id).toString();
};

export const deleteAllNotification = async ({
  user_id,
  access_token,
  total
}) => {
  const notiIdList = await getNotiIdList({ user_id, access_token, total });
  const { data } = await axios.post(
    NOTIFICATIONS.DELETE_ALL_NOTIFICATION_URL +
      `?noti_id=${notiIdList}&user_id=${user_id}&access_token=${access_token}`
  );
  return data;
};

export const deleteNotification = async ({ user_id, access_token, id }) => {
  const { data } = await axios.post(
    NOTIFICATIONS.DELETE_ALL_NOTIFICATION_URL +
      `?noti_id=${id}&user_id=${user_id}&access_token=${access_token}`
  );
  return data;
};
